export default __webpack_public_path__ + "static/media/error-cat@2x.49d6456c.png";